import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OnboardingService {

  private host = environment.host();
  
  constructor(
    private http: HttpClient
  ) { }

  getSalutationList() {
    const requestUrl = environment.host() + 'lookups/?type=SALUTATION_LIST&active=true';
    return this.http.get(requestUrl);
  }

  getCommunicationCategory() {
    const requestUrl = environment.host() + 'lookups/?type=COMMUNICATION_MODE&active=true';
    return this.http.get(requestUrl);
  }

  getEntityTypesList() {
    const requestUrl = environment.host() + 'lookups/?type=Entity Type&active=true';
    return this.http.get(requestUrl);
  }

  getIndustryTypesList() {
    const requestUrl = environment.host() + 'lookups/?type=INDUSTRY_TYPE&active=true';
    return this.http.get(requestUrl);
  }

  createNewSponsor(req: any) {
    let requestUrl = this.host + 'sponsors/';
    return this.http.post(requestUrl, req);
  }

}
